/**
 * Runtime facade — balance/presentation are loaded from `src/data/tables/*`.
 * Do not put tunable numbers or player-facing copy in feature code.
 */
import { buildPortalFfaCatalog } from "./loaders/build-portal-ffa-catalog";

export {
  buildPortalFfaCatalog,
  type PortalFfaCatalog,
  type SummonKind,
  type UnitRuntime,
  type DropMode,
} from "./loaders/build-portal-ffa-catalog";

export const portalFfaCatalog = buildPortalFfaCatalog();

export type TroopKind = keyof typeof portalFfaCatalog.units;
